module.exports = __webpack_public_path__ + "img/regis_n.c2e938dc.png";